import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";
import SimilarEventCard from "@/ui/SimilarEventCard";
import { Form } from "@/ui/Form";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";
import { events_helper } from "@/helpers/events_helper";
import { useLink } from "@/hooks/useLink";
import sourceflowEnums from "@/sourceflow.enums";

export const EventPageContentSection = ({ className, event }) => {
  const [isMobile, setMobile] = useState(true);
  const md = useMediaQuery("only screen and (min-width: 768px)");
  const locale = useLocale();
  const similar = events_helper.fetchSimilar(event, locale);
  const link = useLink();
  const isPastEvent = events_helper.isPastEvent(event);

  const onSubmitDone = () => {
    const teamsLink = event?.[`teams_link`];
    if (teamsLink) {
      window.open(teamsLink, "_blank"); // open new tab
    }
    window.location.href = link("form.complete");
  };

  useEffect(() => {
    setMobile(!md);
  }, [md]);

  return (
    <div className={clsx(className, classes.content)}>
      <Container className="px-2 px-md-3">
        <Row>
          <Col xs={12} md={7}>
            {isMobile && <img className={clsx(classes.content__image, "mb-4")} src={event[`image_${locale}`]} alt="" />}
            <div className="px-2 px-md-0" dangerouslySetInnerHTML={{ __html: event[`body_${locale}`] }} />
          </Col>
          <Col xs={12} md={5}>
            {!isMobile && <img className={classes.content__image} src={event[`image_${locale}`]} alt="" />}
            <div className="mb-4 my-md-5">
              {similar && similar.length > 0 && (
                <>
                  <h5 className="text-secondary mb-3">
                    <a href={link("events")}>Similar events</a>
                  </h5>
                  {similar.map((i) => (
                    <SimilarEventCard className="mb-3" key={i.id} event={i} />
                  ))}
                </>
              )}
            </div>
            {!isPastEvent ? (
              <>
                <a id="signup" data-event={event[`title_${locale}`]} />
                <div className="bg-secondary text-white p-4">
                  <h4 className="mb-2">Sign up here</h4>
                  <p className="fw-normal fs-6">Register with your details here and we’ll get in touch with you.</p>
                  <Form formId={sourceflowEnums.forms.eventSignup[locale]} onSubmitDone={onSubmitDone} />
                </div>
              </>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
